import { render, staticRenderFns } from "./saved-charts-admin.vue?vue&type=template&id=8fc10ad0&"
import script from "./saved-charts-admin.vue?vue&type=script&lang=js&"
export * from "./saved-charts-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports